import React, { Component } from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import _ from 'lodash';
import {
    getReceiptsReferencesList,
    changeCurrentPath,
    resetMainListState,
    resetConsigneeListStateNew,
    getJigyoshaList,
    getKeiyakuKigyouList,
    setReceiptsReferencesList,
    resetMasterReceiptsReferences,
    fetchCsvMasterReceiptsReferences,
} from '../../../actions';

import Header from '../../../common/containers/header';
import Progress from '../../../common/containers/progress'
import SpNav from '../../../common/containers/sp_nav'
import Footer from '../../../common/containers/footer';

import ErrorDialog from '../../../common/components/dialog/error-dialog';
import ReloadModal from '../../../common/components/dialog/reload-dialog';
import LogoutModal from '../../../common/components/dialog/logout-dialog';

import MainButtons from '../../../common/components/main-buttons';

import MasterTable from '../../../common/components/table/master-table';
import AlertDialog from '../../../common/components/dialog/alert-dialog';

const styles = theme => ({
    buttonHide:{
        position:'absolute',
        top:0,
        backgroundColor:'#FFFFFF',
        height:'100%',
        zIndex:6,
    },
    buttonHideLeft:{
        left:-20,
        width:20
    },
    buttonHideRight:{
        right:-100,
        width:100
    },
    cautionText:{
        marginTop:-20,
        color:'#f90c0c'
    }
});

let columns = [
    { name: 'ReceiptJigyoushaCD_Obj', title: '受領 事業者コード' ,width:260, maxLength:10,validations:["required"]},
    { name: 'ChoaiJigyoushaCD_Obj', title: '帳合 事業者コード' ,width:260, maxLength:10,validations:["required"]},
    { name: 'DataTeikyoumotoCD_Obj', title: '提供元コード' ,width:260, maxLength:10,defaultValue:null},
    { name: 'MakerCD_Obj', title: 'メーカーコード' ,width:260, maxLength:10,defaultValue:null},
    { name: 'ChoaisakiCD', title: '帳合先CD',width:200 ,maxLength:20,defaultValue:null,validations:["numLetterSymbol"]},
    { name: 'ApplicationStartDate', title: '適用開始日',width:155 ,maxLength:20,defaultValue:null,validations:["required","dateFormat"]},
    { name: 'ApplicationEndDate', title: '適用終了日',width:155 ,maxLength:20,defaultValue:null,validations:["dateFormat"]},
    { name: 'ApplicationStatus', title: 'ステータス',width:130},
];

let suggestionColumns = {
    ReceiptJigyoushaCD_Obj : [],
    ChoaiJigyoushaCD_Obj : [],
    DataTeikyoumotoCD_Obj : [],
    MakerCD_Obj : []
};

const dateColumns = [
    'ApplicationStartDate',
    'ApplicationEndDate'
]

const viewColumns = [
    "ApplicationStatus"
]

class MasterReceiptsReferences extends Component {

    constructor(props) {
        super(props);
        this.state = {
            rows:[],
            onEdit:false,
            isModify:false,
            dialogOpen : false,
            dialogOpenSave:false,
        }
    }
	/** override methods **/
    UNSAFE_componentWillMount() {
	    const {dispatch} = this.props;
	    this.getReceiptsReferencesList();
        dispatch(getJigyoshaList());
        dispatch(getKeiyakuKigyouList());
        dispatch(resetMainListState());
        dispatch(resetConsigneeListStateNew());

	}
    componentDidMount() {
		const { dispatch, history } = this.props;
		dispatch(changeCurrentPath({ currentPath: history.location.pathname }));
	}
    componentWillUnmount(){
        const { dispatch} = this.props;
        dispatch(resetMasterReceiptsReferences());
    }

    /** event handlers **/
    handleClickSave = () =>{
        const {auth, dispatch} = this.props;
        const {rows} = this.state;
        const addRow = _.filter(rows,{isAdd:true});
        const updateRow = _.filter(rows,(row)=>{return row.isChange || row.isUpdateDelete});
        dispatch(setReceiptsReferencesList({
            addRow,
            updateRow,
            SessionID:auth.SessionID
        }));

    };

    handleClickClear = () =>{
        const {onEdit,isModify} = this.state;
        if(onEdit || isModify){
            this.setState({
                dialogOpen:true
            });
        }
        else{
            this.getReceiptsReferencesList();
        }
    };

    doClear = () =>{
        this.setState({
            dialogOpen:false
        });
        this.getReceiptsReferencesList();

    };

    cancelClear = () =>{
        this.setState({
            dialogOpen:false
        });
    };

    handleGetCurrentList = ({rows,addedRows,editRows}) =>{
        const onEdit = (Object.keys(addedRows).length > 0) || (Object.keys(editRows).length > 0);
        const isModify = rows.some(row=>{
            return row.isAdd || row.isChange || row.isUpdateDelete
        });
        this.setState({rows,onEdit,isModify});
    };

    handleClickDL = () =>{
        const {auth, dispatch} = this.props;
        dispatch(fetchCsvMasterReceiptsReferences({SessionID:auth.SessionID}));
    };

    getReceiptsReferencesList(){
        const {auth, dispatch} = this.props;
        dispatch(getReceiptsReferencesList({SessionID:auth.SessionID}));
    }


    render() {
        const {settings,classes} = this.props;
        const {onEdit, isModify,dialogOpen} = this.state;


        const disabled = onEdit || !(isModify);
        const mainButtons = [
            {type:'SAVE',func:this.handleClickSave, disabled},
            {type:'CLEAR',func:this.handleClickClear},
            {type:'DL',func:this.handleClickDL,hasMargin:true},
        ];


        const {jigyoshaData,keiyakukigyouData} = settings;
        const rows = settings.data;

        suggestionColumns["ReceiptJigyoushaCD_Obj"] = jigyoshaData.flatMap(
            suggestion =>
            (suggestion.ElectronicReceiptFlg === "1") ?
                {
                    value: suggestion.JigyoushaCD,
                    label: suggestion.JigyoushaCD + ' : ' + suggestion.JigyoushaName,
                    name: suggestion.JigyoushaName,
                }
            : []
        );


        suggestionColumns["ChoaiJigyoushaCD_Obj"] = jigyoshaData.flatMap(
            suggestion =>
                (suggestion.JigyoushaIsChoai === "1") ?
                    {
                        value: suggestion.JigyoushaCD,
                        label: suggestion.JigyoushaCD + ' : ' + suggestion.JigyoushaName,
                        name: suggestion.JigyoushaName,
                    }
                    : []
        );

        suggestionColumns["MakerCD_Obj"] = jigyoshaData.flatMap(
            suggestion =>
                (suggestion.JigyoushaIsMaker === "1" && suggestion.MakerElectronicReceiptFlg === "1") ?
                    {
                        value: suggestion.JigyoushaCD,
                        label: suggestion.JigyoushaCD + ' : ' + suggestion.JigyoushaName,
                        name: suggestion.JigyoushaName,
                    }
                    : []
        );

        suggestionColumns["DataTeikyoumotoCD_Obj"] = keiyakukigyouData;


        return (
            <div id="main_container">
                {settings.isFetching &&
                <Progress/>
                }
                <SpNav history={this.props.history}/>
                <Header history={this.props.history}/>
                <article>
                    <section className="title_area">
                        <h2>電子受領照会マスタ</h2>
                    </section>
                    <section className="with_button">
                        <div className={classNames(classes.buttonHide,classes.buttonHideLeft)}/>
                        <div className={classNames(classes.buttonHide,classes.buttonHideRight)}/>
                        <MasterTable
                            dataSource={rows}
                            columns={columns}
                            suggestionColumns={suggestionColumns}
                            dateColumns={dateColumns}
                            viewColumns={viewColumns}
                            defaultSorts={[
                                {columnName:'ReceiptJigyoushaCD',direction:'asc'},
                                {columnName:'ChoaiJigyoushaCD',direction:'asc'},
                                {columnName:'DataTeikyoumotoCD',direction:'asc'},
                                {columnName:'MakerCD',direction:'asc'},
                                {columnName:'ChoaisakiCD',direction:'asc'}
                            ]}
                            getCurrentState={this.handleGetCurrentList}
                        />
                    </section>
                </article>
                <MainButtons buttons={mainButtons}/>
                <Footer/>
                <AlertDialog
                    open={dialogOpen}
                    title={"確認"}
                    text={<span>編集中の内容は破棄されます</span>}
                    okFunction={this.doClear}
                    closeFunction={this.cancelClear}
                />
                <ErrorDialog
                    open={settings.isProcessError}
                />
				<ReloadModal />
                <LogoutModal />
            </div>
        );
    }
}

function mapStateToProps(state) {
  return {
	  navigation : state.navigation,
      auth: state.auth,
      settings : state.masterReceiptsReferencesSettings,

  };
}
export default compose(
    withStyles(styles),
    connect(mapStateToProps)
)(MasterReceiptsReferences);



// WEBPACK FOOTER //
// ./src/routes/master/receipts-references/index.js